import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { CartDrawer } from './components/CartDrawer';
import { Home } from './pages/Home';
import { Boutique } from './pages/Boutique';
import { ProductDetail } from './pages/ProductDetail';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mlua4q7bnttt">
      <CartProvider data-id="element-1" data-mp="2mmcd05ohp6ap">
        <div className="flex min-h-screen w-full flex-col bg-creme font-sans" data-id="element-2" data-mp="2mmvnx2fq2uf8">
          <Header data-id="element-3" data-mp="31b8fzobovt4g" />
          <main className="flex-1" data-id="element-4" data-mp="31bib1qblcqh0">
            <Routes data-id="element-5" data-mp="31ctbbg5tvg3d">
              <Route path="/" element={<Home data-id="element-7" data-mp="2wjqft2hhpwkj" />} data-id="element-6" data-mp="2wka0us2ft12s" />
              <Route path="/boutique" element={<Boutique data-id="element-9" data-mp="2wi5mfg6wwjo9" />} data-id="element-8" data-mp="2wiffxdr618yp" />
              <Route path="/produit/:slug" element={<ProductDetail data-id="element-11" data-mp="28suvsrja05nu" />} data-id="element-10" data-mp="28tw3qn4zwc1c" />
              <Route path="/contact" element={<Contact data-id="element-13" data-mp="23w4g45bdvc2y" />} data-id="element-12" data-mp="23vcjcr61v8b3" />
            </Routes>
          </main>
          <Footer data-id="element-14" data-mp="23ti5fwt74ggi" />
          <CartDrawer data-id="element-15" data-mp="3ikh8gaq64uzi" />
        </div>
      </CartProvider>
    </BrowserRouter>;
}